import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevantempo() {



const cardData = {
keyword: "17 Seater Tempo Traveller on Rent in Pune",
headingDescription: "Ruturaj Enterprises offers comfortable and dependable 17 Seater Tempo Traveller on Rent in Pune for families, friends, corporate teams, wedding groups, school trips, airport transfers, sightseeing programs, picnics, and outstation tours. A 17 seater Tempo Traveller is a practical group transportation choice for larger groups who want to travel together with convenient seating, luggage space, and an organized journey without depending on multiple smaller vehicles.",
topPlaces: [
{
title: "Shirdi",
description: "Shirdi is a major pilgrimage destination that attracts families, devotees, senior citizens, and organized groups from Pune throughout the year. A 17 seater Tempo Traveller provides convenient shared transportation for the temple visit and makes it easier for the entire group to follow a common travel schedule."
},
{
title: "Nashik",
description: "Nashik is popular for pilgrimage tours, temples, vineyards, scenic locations, and weekend holidays. Larger families and groups can choose a 17 seater Tempo Traveller from Pune for comfortable travel while keeping everyone together throughout the journey."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar offers scenic viewpoints, pleasant weather, strawberry farms, and attractive locations for family vacations and group tours. A 17 seater Traveller is suitable for larger groups planning a day trip or multi-day holiday from Pune with luggage and sightseeing requirements."
},
{
title: "Goa",
description: "Goa is a popular destination for family vacations, friends' trips, corporate outings, and group tours from Pune. Hiring a 17 seater Tempo Traveller allows a larger group to travel together on the long route and conveniently manage luggage and planned sightseeing."
},
{
title: "Lonavala",
description: "Lonavala is a favorite destination for weekend trips, corporate outings, family picnics, and group excursions from Pune. A 17 seater Tempo Traveller offers a convenient solution for larger groups who want shared transportation for sightseeing and leisure activities."
},
{
title: "Kolhapur",
description: "Kolhapur attracts visitors for religious destinations, historical attractions, traditional culture, and local sightseeing. A 17 seater Tempo Traveller works well for family groups and organized tours traveling from Pune who prefer one dedicated vehicle for the complete journey."
},
{
title: "Alibaug",
description: "Alibaug is known for its beaches, resorts, coastal scenery, and relaxed weekend atmosphere. Groups traveling from Pune can use a 17 seater Tempo Traveller to keep passengers together while carrying luggage and other items needed for a beach holiday."
},
{
title: "Aurangabad",
description: "Aurangabad, officially Chhatrapati Sambhajinagar, is an important destination for heritage and historical tourism, with attractions such as Ellora and Ajanta within the broader travel circuit. A 17 seater Tempo Traveller is suitable for larger families, educational groups, and tourist parties planning a multi-location tour."
},
{
title: "Panchgani",
description: "Panchgani is a scenic hill station that attracts families, friends, school groups, and tourists looking for a peaceful getaway. A 17 seater vehicle provides practical group transportation from Pune and allows passengers to travel together during the complete tour."
},
{
title: "Kashid",
description: "Kashid is a popular coastal destination known for its beach and relaxing surroundings, making it suitable for group holidays and weekend getaways. A 17 seater Tempo Traveller gives larger groups a convenient way to travel from Pune with passengers and luggage in one shared vehicle."
}
],
services: [
{
name: "17 Seater Tempo Traveller Pune",
description: "Ruturaj Enterprises provides 17 Seater Tempo Traveller Pune services for families, friends, corporate groups, wedding parties, tourists, school groups, and other larger travel parties. The vehicle is suitable for local sightseeing, airport transfers, private functions, weekend trips, and long-distance journeys from Pune."
},
{
name: "17 Seater Tempo Traveller Hire Pune",
description: "17 Seater Tempo Traveller Hire Pune is a convenient solution for groups that need more capacity than a standard car or smaller traveller. It allows passengers to travel together for family vacations, corporate programs, weddings, educational trips, sightseeing tours, and private group journeys."
},
{
name: "17 Seater Tempo Traveller Booking Pune",
description: "17 Seater Tempo Traveller Booking Pune can be arranged for local travel, full-day programs, weekend getaways, outstation tours, wedding transportation, and corporate requirements. Planning the booking in advance helps groups coordinate passenger numbers, pickup locations, destination routes, travel duration, and sightseeing schedules."
},
{
name: "17 Seater AC Tempo Traveller Pune",
description: "17 Seater AC Tempo Traveller Pune is suitable for groups looking for a comfortable air-conditioned travel environment, particularly during warm weather and longer journeys. It can be used for family tours, corporate travel, wedding functions, airport transfers, sightseeing, and outstation vacations."
},
{
name: "17 Seater Luxury Tempo Traveller Pune",
description: "17 Seater Luxury Tempo Traveller Pune is an option for larger groups who prefer a premium-oriented travel experience. It can be considered for corporate movements, family holidays, wedding transportation, special events, private tours, and other journeys where additional comfort is an important consideration."
},
{
name: "17 Seater Tempo Traveller for Outstation Pune",
description: "17 Seater Tempo Traveller for Outstation Pune provides a practical transportation option for larger groups traveling from Pune to destinations across Maharashtra and neighboring states. One dedicated vehicle helps the group stay together and simplifies coordination of luggage, travel stops, sightseeing, and return schedules."
},
{
name: "17 Seater Tempo Traveller for Family Trip Pune",
description: "17 Seater Tempo Traveller for Family Trip Pune is ideal for extended families and relatives planning vacations, pilgrimages, weekend getaways, and destination tours. Everyone can travel together in one vehicle, making it easier to coordinate family members, luggage, pickup points, and planned sightseeing."
},
{
name: "17 Seater Tempo Traveller for Group Travel Pune",
description: "17 Seater Tempo Traveller for Group Travel Pune is designed for friends, relatives, colleagues, and organized groups who want shared transportation. It provides a convenient alternative to arranging several cars and is suitable for both local trips and longer journeys from Pune."
},
{
name: "17 Seater Tempo Traveller for Wedding Pune",
description: "17 Seater Tempo Traveller for Wedding Pune can help transport wedding guests and family members between homes, hotels, ceremony halls, temples, reception venues, and other locations. A dedicated vehicle keeps a larger guest group together and supports better coordination during busy wedding schedules."
},
{
name: "17 Seater Tempo Traveller for Corporate Events Pune",
description: "17 Seater Tempo Traveller for Corporate Events Pune is useful for conferences, seminars, exhibitions, employee gatherings, team outings, training programs, and business events. Larger corporate groups can travel together between offices, hotels, venues, and other planned locations without arranging multiple smaller vehicles."
},
{
name: "17 Seater Tempo Traveller for Airport Pickup Pune",
description: "17 Seater Tempo Traveller for Airport Pickup Pune provides convenient transportation for larger families, corporate teams, wedding groups, and organized travelers arriving at or departing from Pune Airport. It offers a shared solution for passengers with luggage while simplifying airport pickup and drop-off coordination."
},
{
name: "17 Seater Tempo Traveller Near Me Pune",
description: "17 Seater Tempo Traveller Near Me Pune is a useful search for groups looking for a suitable larger-capacity traveller rental in Pune. Ruturaj Enterprises supports requirements ranging from local sightseeing and airport transfers to weddings, corporate travel, family trips, and outstation tours."
},
{
name: "Affordable 17 Seater Tempo Traveller Pune",
description: "Affordable 17 Seater Tempo Traveller Pune offers a practical group travel solution when several passengers need to reach the same destination. Sharing one vehicle can reduce the complexity of coordinating multiple cars while providing a convenient transportation arrangement for tours, functions, picnics, and outstation journeys."
},
{
name: "17 Seater Traveller Rental Service Pune",
description: "17 Seater Traveller Rental Service Pune can be arranged for short trips, full-day travel, multi-day tours, events, airport transfers, family vacations, and corporate requirements. The rental plan can be organized according to the number of passengers, destination, duration, pickup points, and overall itinerary."
},
{
name: "17 Seater Tempo Traveller for Picnic Pune",
description: "17 Seater Tempo Traveller for Picnic Pune is suitable for larger families, school groups, office teams, friends, and community groups planning recreational outings. The vehicle allows passengers to travel together while carrying food, bags, outdoor equipment, and other essentials needed for a comfortable picnic."
},
{
name: "17 Seater Tempo Traveller for School Trip Pune",
description: "17 Seater Tempo Traveller for School Trip Pune provides organized transportation for educational excursions, recreational outings, museum visits, nature trips, historical tours, and student activities. Schools and organizers can plan suitable pickup and drop-off arrangements while keeping students and accompanying staff together."
},
{
name: "17 Seater Tempo Traveller for Local Sightseeing Pune",
description: "17 Seater Tempo Traveller for Local Sightseeing Pune is a convenient choice for larger families, tourist groups, visiting relatives, and organized parties exploring Pune's historical, cultural, religious, and recreational attractions. A single vehicle makes it easier to follow a planned sightseeing route without coordinating several cars."
},
{
name: "17 Seater Tempo Traveller for Marriage Pune",
description: "17 Seater Tempo Traveller for Marriage Pune is useful for transporting larger groups of relatives and guests during marriage ceremonies and related functions. It can support planned movement between hotels, homes, temples, banquet halls, reception venues, and other locations included in the wedding schedule."
},
{
name: "17 Seater Tempo Traveller for Corporate Travel Pune",
description: "17 Seater Tempo Traveller for Corporate Travel Pune provides shared transportation for employee movements, business meetings, training programs, client visits, corporate tours, and office activities. It is particularly useful when a larger team needs to travel together according to a fixed business schedule."
},
{
name: "17 Seater Tempo Traveller for Outstation Trip Pune",
description: "17 Seater Tempo Traveller for Outstation Trip Pune is suitable for larger groups planning weekend getaways, family holidays, pilgrimage tours, destination visits, and multi-day journeys. A dedicated vehicle makes it easier to coordinate departure times, sightseeing stops, luggage, passengers, and return travel."
},
{
name: "17 Seater Luxury Traveller Hire Pune",
description: "17 Seater Luxury Traveller Hire Pune is suitable for larger groups who want a more premium transportation experience for special occasions and important journeys. It can be arranged for corporate travel, wedding groups, family vacations, private tours, and special events where enhanced comfort is preferred."
},
{
name: "17 Seater AC Traveller Rental Pune",
description: "17 Seater AC Traveller Rental Pune offers a comfortable shared travel option for larger groups traveling within Pune or to outstation destinations. Air-conditioned travel is especially useful for longer routes, sightseeing tours, family vacations, corporate journeys, wedding transportation, and airport transfers."
}
],
tableData: [
["17 Seater Tempo Traveller Pune", "17 Seater Tempo Traveller Hire Pune"],
["17 Seater Tempo Traveller Booking Pune", "17 Seater AC Tempo Traveller Pune"],
["17 Seater Luxury Tempo Traveller Pune", "17 Seater Tempo Traveller for Outstation Pune"],
["17 Seater Tempo Traveller for Family Trip Pune", "17 Seater Tempo Traveller for Group Travel Pune"],
["17 Seater Tempo Traveller for Wedding Pune", "17 Seater Tempo Traveller for Corporate Events Pune"],
["17 Seater Tempo Traveller for Airport Pickup Pune", "17 Seater Tempo Traveller Near Me Pune"],
["Affordable 17 Seater Tempo Traveller Pune", "17 Seater Traveller Rental Service Pune"],
["17 Seater Tempo Traveller for Picnic Pune", "17 Seater Tempo Traveller for School Trip Pune"],
["17 Seater Tempo Traveller for Local Sightseeing Pune", "17 Seater Tempo Traveller for Marriage Pune"],
["17 Seater Tempo Traveller for Corporate Travel Pune", "17 Seater Tempo Traveller for Outstation Trip Pune"],
["17 Seater Luxury Traveller Hire Pune", "17 Seater AC Traveller Rental Pune"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Capacity for Larger Groups",
WhyChoosedescription: "A 17 seater Tempo Traveller is well suited for groups that need more passenger capacity than a smaller traveller can provide. Families, friends, corporate teams, wedding parties, school groups, and tourists can remain together in one dedicated vehicle throughout their journey."
},
{
WhyChooseheading: "Convenient Alternative to Multiple Cars",
WhyChoosedescription: "Traveling in several cars can make group coordination difficult, particularly when vehicles need to follow the same route and arrive at the same destination. A 17 seater Traveller brings the group together, simplifying route planning, pickup coordination, parking requirements, and travel communication."
},
{
WhyChooseheading: "Suitable for Outstation Tours",
WhyChoosedescription: "Long-distance journeys from Pune often involve multiple passengers, luggage, sightseeing stops, and fixed travel schedules. A dedicated 17 seater Tempo Traveller provides a practical shared transportation arrangement for family holidays, pilgrimages, weekend trips, and multi-day tours."
},
{
WhyChooseheading: "Useful for Wedding Transportation",
WhyChoosedescription: "Wedding groups frequently need transportation between hotels, homes, ceremony venues, reception halls, and other locations. A 17 seater vehicle can help move a larger number of relatives or guests together while supporting the timing and coordination required during wedding functions."
},
{
WhyChooseheading: "Comfort Options for Different Journeys",
WhyChoosedescription: "Travel preferences can change depending on weather, distance, and the purpose of the trip. AC and luxury-oriented 17 seater options provide choices for passengers who want additional comfort during corporate journeys, family vacations, sightseeing tours, special events, and longer routes."
},
{
WhyChooseheading: "Practical for Corporate Groups",
WhyChoosedescription: "Companies can use larger traveller arrangements for conferences, employee outings, training programs, meetings, exhibitions, and business events. Keeping team members together can make transportation planning more straightforward and help maintain a common schedule throughout the event."
},
{
WhyChooseheading: "Convenient for School and Picnic Trips",
WhyChoosedescription: "Educational excursions and recreational outings often involve students, teachers, organizers, or larger groups traveling to the same destination. A 17 seater Tempo Traveller provides a shared transportation solution that can accommodate the group and their essential travel items."
},
{
WhyChooseheading: "Flexible for Local and Long-Distance Travel",
WhyChoosedescription: "The vehicle can be used for many different travel requirements, from Pune sightseeing and airport transfers to family vacations and outstation tours. Ruturaj Enterprises helps groups plan transportation around their passenger count, destination, journey duration, pickup requirements, and itinerary."
}
]
};







const faqData = [
{
question: "What makes a 17 Seater Tempo Traveller useful for group travel in Pune?",
answer: "A 17 Seater Tempo Traveller is designed for larger groups that want to travel together in one vehicle. Ruturaj Enterprises provides this option for family outings, corporate programs, weddings, picnics, sightseeing tours, airport transfers, and outstation journeys."
},
{
question: "Can I rent a 17 Seater Tempo Traveller in Pune for an outstation tour?",
answer: "Outstation groups can hire a 17 Seater Tempo Traveller from Pune for destinations across Maharashtra and other travel routes. It is particularly useful for multi-day vacations, pilgrimage tours, weekend trips, and organized group journeys."
},
{
question: "Is an AC 17 Seater Tempo Traveller available for rent?",
answer: "Groups seeking a comfortable travel environment can inquire about an AC 17 Seater Tempo Traveller. Ruturaj Enterprises can help identify a suitable vehicle based on the passenger count, route, travel duration, and preferred features."
},
{
question: "Can a 17 Seater Tempo Traveller be booked for family vacations?",
answer: "Large families can use a 17 Seater Tempo Traveller for holidays and group tours where everyone prefers to remain together. The shared vehicle arrangement also makes it easier to coordinate departure times, sightseeing stops, and return travel."
},
{
question: "Can I use a 17 Seater Tempo Traveller for wedding transportation?",
answer: "Wedding groups can arrange a 17 Seater Tempo Traveller for transporting relatives and guests between residences, hotels, marriage halls, event venues, railway stations, and airports as part of their function transportation requirements."
},
{
question: "Are 17 Seater Tempo Travellers suitable for corporate travel?",
answer: "Companies can hire a 17 Seater Tempo Traveller for employee transportation, business meetings, conferences, corporate events, team-building activities, training programs, and official trips involving a larger group."
},
{
question: "Can I book a 17 Seater Tempo Traveller for a picnic?",
answer: "A 17 Seater vehicle can be a convenient choice for group picnics and recreational outings from Pune. Friends, families, schools, and organizations can travel together while following a planned itinerary and keeping transportation arrangements simple."
},
{
question: "Is a 17 Seater Tempo Traveller useful for Pune sightseeing?",
answer: "Groups visiting Pune attractions can hire a 17 Seater Tempo Traveller when several passengers need to move between multiple sightseeing locations. A single vehicle allows the group to maintain one schedule without dividing into separate cars."
},
{
question: "Can a 17 Seater Tempo Traveller be used for airport pickup?",
answer: "Large families, corporate teams, and tour groups can use a 17 Seater Tempo Traveller for Pune Airport transfers. The arrangement is particularly helpful when several passengers are traveling together with multiple pieces of luggage."
},
{
question: "How do I reserve a 17 Seater Tempo Traveller on rent in Pune?",
answer: "For a booking with Ruturaj Enterprises, provide your pickup location, destination, travel date, number of passengers, trip duration, and preferred vehicle requirements. The rental can then be arranged according to your group's travel plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sachin More",
feedback:
"Ruturaj Enterprises was our choice for a 17 Seater Tempo Traveller during a family tour from Pune. The vehicle worked well for our larger group, and traveling together made the complete journey much more convenient. We were pleased with the overall arrangement.",
rating: 5
},
{
id: 2,
name: "Miss. Mitali Desai",
feedback:
"Our corporate team booked a 17 Seater Tempo Traveller from Ruturaj Enterprises for an event outside Pune. The group transportation was easy to coordinate, and everyone could travel together comfortably according to our planned schedule. The service was a good fit for our requirement.",
rating: 5
}
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Tempo Traveller on Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/17-seater-tempo-traveller-on-rent-in-pune.webp",
  "description":
    "17 Seater Tempo Traveller on Rent in Pune from Ruturaj Enterprises is a spacious group transportation option for families, friends, corporate teams, wedding groups, tourists, school and college groups traveling together from Pune. 17 Seater Tempo Traveller Pune is suitable for local sightseeing, airport transfers, family vacations, corporate outings, wedding transportation, pilgrimage tours, weekend getaways and long-distance outstation journeys. 17 Seater Tempo Traveller Hire Pune provides a practical way for larger groups to travel together in one vehicle rather than arranging several cars, while 17 Seater Tempo Traveller Booking Pune can be planned according to the pickup point, destination, travel dates, duration and passenger requirements. 17 Seater AC Tempo Traveller Pune offers a comfortable environment for warm-weather travel and longer journeys, while 17 Seater Luxury Tempo Traveller Pune is suitable for premium group travel, corporate events, weddings, special occasions and organized tours. 17 Seater Tempo Traveller for Outstation Pune can be arranged for popular destinations including Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran, Ratnagiri, Ganpatipule and other Maharashtra and interstate destinations. The vehicle is also suitable for 17 Seater Tempo Traveller for Family Trip Pune, 17 Seater Tempo Traveller for Group Travel Pune, friends trips, tourist tours, school excursions, college tours, industrial visits and customized multi-day road trips. Wedding requirements can include guest transfers between hotels, wedding venues, reception locations, airports and railway stations, while corporate requirements may include employee transportation, conferences, seminars, exhibitions, meetings, business visits and team outings. Pune Darshan, temple tours, religious journeys, pilgrimage travel and local sightseeing can also be organized with a dedicated driver. Pickup and drop arrangements can be planned from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and nearby Pune areas. Ruturaj Enterprises supports local and outstation 17 Seater Tempo Traveller rental requirements for full-day travel, weekend trips, multi-day tours, corporate transportation, wedding guest movement, family holidays, sightseeing and customized group journeys from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/17-seater-tempo-traveller-on-rent-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>17 Seater Tempo Traveller on Rent in Pune | 17 Seater Tempo Traveller Pune | +91 9763381382</title>

  <meta
    name="description"
    content="17 Seater Tempo Traveller on Rent in Pune for family trips, group tours, corporate events, weddings, sightseeing, airport transfers and outstation journeys with driver."
  />

  <meta
    name="keywords"
    content="17 Seater Tempo Traveller Pune, 17 Seater Tempo Traveller Hire Pune, 17 Seater Tempo Traveller Booking Pune, 17 Seater AC Tempo Traveller Pune, 17 Seater Luxury Tempo Traveller Pune, 17 Seater Tempo Traveller for Outstation Pune, 17 Seater Tempo Traveller for Family Trip Pune, 17 Seater Tempo Traveller for Group Travel Pune, 17 Seater Tempo Traveller on Rent in Pune, 17 Seater Tempo Traveller Rental Pune, 17 Seater Tempo Traveller Hire in Pune, 17 Seater Tempo Traveller Booking Pune, 17 Seater Tempo Traveller with Driver Pune, 17 Seater AC Tempo Traveller on Rent Pune, 17 Seater AC Tempo Traveller Hire Pune, 17 Seater AC Tempo Traveller Rental Pune, 17 Seater Luxury Tempo Traveller on Rent Pune, 17 Seater Luxury Tempo Traveller Hire Pune, 17 Seater Luxury Tempo Traveller Rental Pune, Premium 17 Seater Tempo Traveller Pune, Affordable 17 Seater Tempo Traveller Pune, 17 Seater Tempo Traveller for Group Tour Pune, 17 Seater Tempo Traveller for Friends Trip Pune, 17 Seater Tempo Traveller for Family Tour Pune, 17 Seater Tempo Traveller for Family Vacation Pune, 17 Seater Tempo Traveller for Weekend Trip Pune, 17 Seater Tempo Traveller for Holiday Trip Pune, 17 Seater Tempo Traveller for Road Trip Pune, 17 Seater Tempo Traveller for Sightseeing Pune, 17 Seater Tempo Traveller for Local Sightseeing Pune, 17 Seater Tempo Traveller for Pune Darshan, 17 Seater Tempo Traveller for Maharashtra Tour Pune, 17 Seater Tempo Traveller for Goa Trip Pune, 17 Seater Tempo Traveller for Mumbai Trip Pune, 17 Seater Tempo Traveller for Lonavala Trip Pune, 17 Seater Tempo Traveller for Mahabaleshwar Trip Pune, 17 Seater Tempo Traveller for Panchgani Trip Pune, 17 Seater Tempo Traveller for Nashik Trip Pune, 17 Seater Tempo Traveller for Shirdi Trip Pune, 17 Seater Tempo Traveller for Kolhapur Trip Pune, 17 Seater Tempo Traveller for Satara Trip Pune, 17 Seater Tempo Traveller for Konkan Trip Pune, 17 Seater Tempo Traveller for Alibaug Trip Pune, 17 Seater Tempo Traveller for Matheran Trip Pune, 17 Seater Tempo Traveller for Ratnagiri Trip Pune, 17 Seater Tempo Traveller for Ganpatipule Trip Pune, 17 Seater Tempo Traveller for Dapoli Trip Pune, 17 Seater Tempo Traveller for Outstation Trip Pune, 17 Seater Tempo Traveller Outstation Rental Pune, 17 Seater Tempo Traveller One Way Pune, 17 Seater Tempo Traveller Round Trip Pune, 17 Seater Tempo Traveller Full Day Rental Pune, 17 Seater Tempo Traveller Multi Day Rental Pune, 17 Seater Tempo Traveller Weekend Rental Pune, 17 Seater Tempo Traveller Tour Package Pune, 17 Seater Tempo Traveller Sightseeing Package Pune, 17 Seater Tempo Traveller Family Tour Package Pune, 17 Seater Tempo Traveller Group Tour Package Pune, 17 Seater Tempo Traveller Corporate Tour Pune, 17 Seater Tempo Traveller Corporate Travel Pune, 17 Seater Tempo Traveller for Corporate Events Pune, 17 Seater Tempo Traveller for Corporate Outing Pune, 17 Seater Tempo Traveller for Employee Transportation Pune, 17 Seater Tempo Traveller for Office Trip Pune, 17 Seater Tempo Traveller for Company Event Pune, 17 Seater Tempo Traveller for Business Travel Pune, 17 Seater Tempo Traveller for Conference Pune, 17 Seater Tempo Traveller for Seminar Pune, 17 Seater Tempo Traveller for Exhibition Pune, 17 Seater Tempo Traveller for Training Pune, 17 Seater Tempo Traveller for Industrial Visit Pune, 17 Seater Tempo Traveller for Wedding Pune, 17 Seater Tempo Traveller for Wedding Guest Pune, 17 Seater Tempo Traveller for Marriage Pune, 17 Seater Tempo Traveller for Reception Pune, 17 Seater Tempo Traveller for Destination Wedding Pune, 17 Seater Tempo Traveller for Wedding Guest Transportation Pune, 17 Seater Tempo Traveller for Event Transportation Pune, 17 Seater Tempo Traveller for Airport Transfer Pune, 17 Seater Tempo Traveller for Airport Pickup Pune, 17 Seater Tempo Traveller for Airport Drop Pune, 17 Seater Tempo Traveller for Pune Airport, 17 Seater Tempo Traveller for Railway Station Transfer Pune, 17 Seater Tempo Traveller for Pune Railway Station, 17 Seater Tempo Traveller for Hotel Transfer Pune, 17 Seater Tempo Traveller for Resort Transfer Pune, 17 Seater Tempo Traveller for Guest Pickup Pune, 17 Seater Tempo Traveller for Guest Drop Pune, 17 Seater Tempo Traveller for School Trip Pune, 17 Seater Tempo Traveller for College Trip Pune, 17 Seater Tempo Traveller for Student Group Pune, 17 Seater Tempo Traveller for Picnic Pune, 17 Seater Tempo Traveller for Temple Tour Pune, 17 Seater Tempo Traveller for Pilgrimage Pune, 17 Seater Tempo Traveller for Religious Tour Pune, 17 Seater Tempo Traveller for Tourist Group Pune, 17 Seater Tempo Traveller for Group Transportation Pune, 17 Seater Tempo Traveller for Family Transportation Pune, 17 Seater Tempo Traveller for Corporate Transportation Pune, 17 Seater Tempo Traveller for Event Transportation Pune, 17 Seater Tempo Traveller Rental Near Pune, 17 Seater Tempo Traveller Hire Near Pune, 17 Seater Tempo Traveller Booking Near Pune, 17 Seater Tempo Traveller Rental Pimpri Chinchwad, 17 Seater Tempo Traveller Hire Pimpri Chinchwad, 17 Seater Tempo Traveller Rental Wakad, 17 Seater Tempo Traveller Rental Hinjewadi, 17 Seater Tempo Traveller Rental Kothrud, 17 Seater Tempo Traveller Rental Baner, 17 Seater Tempo Traveller Rental Aundh, 17 Seater Tempo Traveller Rental Viman Nagar, 17 Seater Tempo Traveller Rental Kharadi, 17 Seater Tempo Traveller Rental Hadapsar, 17 Seater Tempo Traveller Rental Kondhwa, 17 Seater Tempo Traveller Rental Katraj, 17 Seater Tempo Traveller Rental Shivajinagar, 17 Seater Tempo Traveller Rental Swargate, 17 Seater Tempo Traveller Rental Pimpri, 17 Seater Tempo Traveller Rental Chinchwad, 17 Seater Tempo Traveller Rental Talegaon, 17 Seater Tempo Traveller Rental Moshi, 17 Seater Tempo Traveller Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onesevantempo ;